import React from 'react'
import { Link, FormattedMessage, injectIntl } from "gatsby-plugin-intl"

import akzent_es from '../images/akzent-f-es.png'
import akzent_en from '../images/akzent-f-en.png'
import mail from '../images/icon-mail.svg'
import facebook from '../images/icon-facebook.svg'
import twitter from '../images/icon-twitter.svg'
import linked from '../images/icon-linkedin.svg'
import doc from '../images/icon-documento.svg'
import akz_zero from '../images/AKZENTZERO.blanco.png'

const Footer = ({intl}) => {

	const locale = intl.locale

	return (
		<footer className="main-footer">
			<div className="top">
				<div className="logo">
					<Link to="/" title="Akzent">
						<img src={ locale === 'es' ? akzent_es : akzent_en } alt="Akzent" className="img-fluid"/>
					</Link>
				</div>
				<div className="info">
					<a href="mailto:hello@akzent.mx" className="link">
						<img src={mail} alt="Mail" width="18" height="14"/>
						hello@akzent.mx
					</a>
					<span className="divider"></span>
					<Link className="btn btn-solid verde" to="/landingapps/suite">
						<FormattedMessage id="header.acceso" />
					</Link>
					{/*<a href="https://www.akzent.mx/Account/Login.aspx" target="_blank" rel="noopener noreferrer" className="btn btn-solid verde"><FormattedMessage id="header.acceso" /></a>*/}
				</div>
			</div>
			<hr/>
			<div className="bottom">
				<nav>
					<ul>
						<li>
							<Link className="link" to="/"><FormattedMessage id="header.inicio" /></Link>
						</li>
						<li>
							<Link className="link" to="/empresa"><FormattedMessage id="header.empresa" /></Link>
						</li>
						<li>
							<a href="https://blog.akzent.mx/biblioteca" target="_self" className="link" ><FormattedMessage id="header.recursos" /></a>
						</li>
						<li>
							<Link className="link" to="/contacto"><FormattedMessage id="header.contacto" /></Link>
						</li>
					</ul>
					<ul>
						<li>
							<Link to="/servicios/transportacion-terrestre"><FormattedMessage id="header.terrestre" /></Link>
						</li>
						<li>
							<Link to="/servicios/transportacion-aerea"><FormattedMessage id="header.aerea" /></Link>
						</li>
						<li>
							<Link to="/servicios/transportacion-maritima"><FormattedMessage id="header.maritima" /></Link>
						</li>
						<li>
							<Link to="/servicios/almacen-distribucion"><FormattedMessage id="header.almacen" /></Link>
						</li>
						<li>
							<Link to="/servicios/agencia-aduanal"><FormattedMessage id="header.agencia" /></Link>
						</li>
					</ul>
				</nav>
				<div className="datos">
					<div className="row tels">
						<div className="col-6">
							<a className="btn" href="tel:(800)2259368">
								<svg className="mr-2" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1429 12.0268C14.1429 12.2076 14.1094 12.4453 14.0424 12.7399C13.9754 13.0279 13.9051 13.2556 13.8315 13.423C13.6908 13.7578 13.2824 14.1127 12.606 14.4877C11.9766 14.8292 11.3538 15 10.7377 15C10.5569 15 10.3795 14.9899 10.2054 14.9698C10.0312 14.9431 9.83705 14.8995 9.62277 14.8393C9.41518 14.779 9.25781 14.7321 9.15067 14.6986C9.05022 14.6585 8.86607 14.5881 8.59822 14.4877C8.33036 14.3873 8.1663 14.327 8.10603 14.3069C7.44978 14.0725 6.86384 13.7946 6.34821 13.4732C5.49777 12.9442 4.61384 12.221 3.69643 11.3035C2.77902 10.3861 2.0558 9.50221 1.52679 8.65176C1.20536 8.13613 0.927455 7.5502 0.69308 6.89395C0.672991 6.83368 0.612723 6.66962 0.512277 6.40176C0.41183 6.1339 0.341518 5.94975 0.301339 5.8493C0.267857 5.74216 0.220982 5.5848 0.160714 5.37721C0.100446 5.16292 0.0569196 4.96872 0.0301339 4.79462C0.0100446 4.62051 0 4.44305 0 4.26225C0 3.64618 0.170759 3.02341 0.512277 2.39395C0.887277 1.71761 1.24219 1.30913 1.57701 1.1685C1.74442 1.09484 1.9721 1.02453 2.26004 0.957563C2.55469 0.890599 2.79241 0.857117 2.97321 0.857117C3.06696 0.857117 3.13728 0.867162 3.18415 0.887251C3.30469 0.92743 3.48214 1.18189 3.71652 1.65064C3.79018 1.77788 3.89063 1.95868 4.01786 2.19305C4.14509 2.42743 4.26228 2.64172 4.36942 2.83591C4.47656 3.02341 4.58036 3.20087 4.6808 3.36828C4.70089 3.39506 4.75781 3.47877 4.85156 3.61939C4.95201 3.76002 5.02567 3.88055 5.07255 3.981C5.11942 4.07475 5.14286 4.1685 5.14286 4.26225C5.14286 4.39618 5.04576 4.56359 4.85156 4.76448C4.66406 4.96538 4.45647 5.14953 4.2288 5.31694C4.00781 5.48435 3.80022 5.6618 3.60603 5.8493C3.41853 6.0368 3.32478 6.19082 3.32478 6.31136C3.32478 6.37163 3.34152 6.44863 3.375 6.54238C3.40848 6.62944 3.43527 6.6964 3.45536 6.74328C3.48214 6.79015 3.52902 6.87051 3.59598 6.98435C3.66964 7.09819 3.70982 7.1618 3.71652 7.1752C4.22545 8.09261 4.80804 8.87944 5.46429 9.53569C6.12054 10.1919 6.90737 10.7745 7.82478 11.2835C7.83817 11.2902 7.90179 11.3303 8.01563 11.404C8.12946 11.471 8.20982 11.5178 8.2567 11.5446C8.30357 11.5647 8.37054 11.5915 8.45759 11.625C8.55134 11.6585 8.62835 11.6752 8.68862 11.6752C8.80915 11.6752 8.96317 11.5814 9.15067 11.3939C9.33817 11.1998 9.51563 10.9922 9.68304 10.7712C9.85045 10.5435 10.0346 10.3359 10.2355 10.1484C10.4364 9.95422 10.6038 9.85712 10.7377 9.85712C10.8315 9.85712 10.9252 9.88055 11.019 9.92743C11.1194 9.9743 11.24 10.048 11.3806 10.1484C11.5212 10.2422 11.6049 10.2991 11.6317 10.3192C11.7991 10.4196 11.9766 10.5234 12.1641 10.6306C12.3583 10.7377 12.5725 10.8549 12.8069 10.9821C13.0413 11.1093 13.2221 11.2098 13.3493 11.2835C13.8181 11.5178 14.0725 11.6953 14.1127 11.8158C14.1328 11.8627 14.1429 11.933 14.1429 12.0268Z" fill="currentColor"/></svg>
								<header>
									<FormattedMessage id="footer.mexico" />
									<small><FormattedMessage id="footer.sincosto" /></small>
								</header>
								<strong>(800) 2259368</strong>
							</a>
						</div>
						<div className="col-6">
							<a className="btn" href="tel:18669236330">
								<svg className="mr-2" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1429 12.0268C14.1429 12.2076 14.1094 12.4453 14.0424 12.7399C13.9754 13.0279 13.9051 13.2556 13.8315 13.423C13.6908 13.7578 13.2824 14.1127 12.606 14.4877C11.9766 14.8292 11.3538 15 10.7377 15C10.5569 15 10.3795 14.9899 10.2054 14.9698C10.0312 14.9431 9.83705 14.8995 9.62277 14.8393C9.41518 14.779 9.25781 14.7321 9.15067 14.6986C9.05022 14.6585 8.86607 14.5881 8.59822 14.4877C8.33036 14.3873 8.1663 14.327 8.10603 14.3069C7.44978 14.0725 6.86384 13.7946 6.34821 13.4732C5.49777 12.9442 4.61384 12.221 3.69643 11.3035C2.77902 10.3861 2.0558 9.50221 1.52679 8.65176C1.20536 8.13613 0.927455 7.5502 0.69308 6.89395C0.672991 6.83368 0.612723 6.66962 0.512277 6.40176C0.41183 6.1339 0.341518 5.94975 0.301339 5.8493C0.267857 5.74216 0.220982 5.5848 0.160714 5.37721C0.100446 5.16292 0.0569196 4.96872 0.0301339 4.79462C0.0100446 4.62051 0 4.44305 0 4.26225C0 3.64618 0.170759 3.02341 0.512277 2.39395C0.887277 1.71761 1.24219 1.30913 1.57701 1.1685C1.74442 1.09484 1.9721 1.02453 2.26004 0.957563C2.55469 0.890599 2.79241 0.857117 2.97321 0.857117C3.06696 0.857117 3.13728 0.867162 3.18415 0.887251C3.30469 0.92743 3.48214 1.18189 3.71652 1.65064C3.79018 1.77788 3.89063 1.95868 4.01786 2.19305C4.14509 2.42743 4.26228 2.64172 4.36942 2.83591C4.47656 3.02341 4.58036 3.20087 4.6808 3.36828C4.70089 3.39506 4.75781 3.47877 4.85156 3.61939C4.95201 3.76002 5.02567 3.88055 5.07255 3.981C5.11942 4.07475 5.14286 4.1685 5.14286 4.26225C5.14286 4.39618 5.04576 4.56359 4.85156 4.76448C4.66406 4.96538 4.45647 5.14953 4.2288 5.31694C4.00781 5.48435 3.80022 5.6618 3.60603 5.8493C3.41853 6.0368 3.32478 6.19082 3.32478 6.31136C3.32478 6.37163 3.34152 6.44863 3.375 6.54238C3.40848 6.62944 3.43527 6.6964 3.45536 6.74328C3.48214 6.79015 3.52902 6.87051 3.59598 6.98435C3.66964 7.09819 3.70982 7.1618 3.71652 7.1752C4.22545 8.09261 4.80804 8.87944 5.46429 9.53569C6.12054 10.1919 6.90737 10.7745 7.82478 11.2835C7.83817 11.2902 7.90179 11.3303 8.01563 11.404C8.12946 11.471 8.20982 11.5178 8.2567 11.5446C8.30357 11.5647 8.37054 11.5915 8.45759 11.625C8.55134 11.6585 8.62835 11.6752 8.68862 11.6752C8.80915 11.6752 8.96317 11.5814 9.15067 11.3939C9.33817 11.1998 9.51563 10.9922 9.68304 10.7712C9.85045 10.5435 10.0346 10.3359 10.2355 10.1484C10.4364 9.95422 10.6038 9.85712 10.7377 9.85712C10.8315 9.85712 10.9252 9.88055 11.019 9.92743C11.1194 9.9743 11.24 10.048 11.3806 10.1484C11.5212 10.2422 11.6049 10.2991 11.6317 10.3192C11.7991 10.4196 11.9766 10.5234 12.1641 10.6306C12.3583 10.7377 12.5725 10.8549 12.8069 10.9821C13.0413 11.1093 13.2221 11.2098 13.3493 11.2835C13.8181 11.5178 14.0725 11.6953 14.1127 11.8158C14.1328 11.8627 14.1429 11.933 14.1429 12.0268Z" fill="currentColor"/></svg>
								<header>
									<FormattedMessage id="footer.usa" />
									<small><FormattedMessage id="footer.sincosto" /></small>
								</header>
								<strong>1 866 9236330</strong>
							</a>
						</div>
					</div>
					<div className="row mt-5 extras">
						<div className="col-6">
							<a href={intl.formatMessage({ id: "footer.documento" })} target="_blank" rel="noopener noreferrer" className="btn">
								<img src={doc} alt="Doc"/>
								<strong><FormattedMessage id="footer.descargar" /></strong> 
							</a>
							<a href={intl.formatMessage({ id: "footer.documentoaviso" })} target="_blank" rel="noopener noreferrer" className="btn">
								<img src={doc} alt="Doc"/>
								<strong><FormattedMessage id="footer.avisoprivacidad" /></strong> 
							</a>
						</div>
						<div className="col-6">
							<div className="social pl-2">
								<a href="https://www.facebook.com/Akzent-Group-1280221735478077/" target="_blank" rel="noopener noreferrer">
									<img src={facebook} alt="Facebook"/>
								</a>
								<a href="https://twitter.com/akzentgroup" target="_blank" rel="noopener noreferrer">
									<img src={twitter} alt="Twitter"/>
								</a>
								<a href="https://www.linkedin.com/company/akzent-group" target="_blank" rel="noopener noreferrer">
									<img src={linked} alt="LinkedIn"/>
								</a>
								<p>&nbsp;</p>
								<a href={intl.formatMessage({ id: "footer.url_akz_zero" })} target="_blank" rel="noopener noreferrer">
									<img src={akz_zero} alt="Akzent-Zero" width="132" height="21" />
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default injectIntl(Footer)
